import React, {useEffect, useState} from "react";
import {
    Grid,
    Card,
    Typography,
    Button,
    Avatar,
    Box,
    TextField,
    Container,
    GridItemsAlignment,
} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {makeStyles, Theme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useSnackbar} from "notistack";
import {DropZone} from "../../Components";
import {ReactComponent as DocSVG} from "../../Images/vetDoctor.svg";
import {colorPrimary, colorSecondary, colorWhite} from "../../Constants/theme";
import {appointmentsAdvice, setType} from "../../Constants/serviceType";
import {getGuestBookingPrice} from "../../utils/guestBooking";
import Image from "material-ui-image";

import API from "../../helpers/apiHelpers";
import {useDispatch, useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {createCredit} from "../../redux/credits/credits.actions";
import {
    postAppointmentRequest,
    updateAdditionalInfo,
    updatePaymentMethod, updatePickedTimeSlot,
    uploadPhotos, uploadVideo, cleanUpPhoto, cleanUpVideo,
    updatePromotionCode,
} from "../../redux/scheduleAppointment/scheduling.actions";
import {setPrice as setSchedulePrice} from "../../redux/scheduleAppointment/scheduling.reducers";
import {getUserByID} from "../../redux/user/user.actions";
import moment from "moment/moment";
import jsPDF from "jspdf";
import AppointmentTime from "../../Components/AppointmentTime";
import {specialities} from "../../Constants/specialities";
import {api_getCreditPrices, api_getCreditRequestsCountByType} from "../../redux/credits/credits.api";

const useStyle = makeStyles((theme: Theme) => ({
    cardWrapper: {
        marginTop: "10vh",
        marginBottom: "10vh",
    },
    wrapper: {
        backgroundColor: "#F7F3EE",
        height: "100%",
    },
    rowContainer: {
        marginTop: "20px",
        padding: "10px 0"
    },
    doctorContainer: {
        marginTop: 20,
        alignSelf: "flex-start",
        columnGap: 10,
        padding: "10px 0",
        flexWrap: "nowrap"
    },
    doctorDescription: {
        marginTop: 15
    },
    spanContainer: {
        fontFamily: "DM Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "24px",
        lineHeight: "26px"
    },
    selectTimeSLot: {
        position: "relative",
        marginLeft: 10,
        width: 217,
        [theme.breakpoints.down("sm")]: {
            marginTop: 10,
            marginLeft: 0,
        }
    },
    availabilityContainer: {
        marginTop: "20px",
    },
    spanOptions: {
        fontFamily: "DM Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "18px",
        lineHeight: "26px",
        marginBottom: 10,
        width: 100
    },
    avatar: {
        width: 95,
        height: 95,
        cursor: "pointer",
        backgroundColor: colorWhite
    },
    addTimeOption: {
        color: colorPrimary,
        cursor: "pointer",
    },
    timeContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginTop: 20,
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            width: "auto",
        }
    },
    dropZone: {
        display: "flex",
        gap: 20,
        justifyContent: "center",
        flexWrap: "wrap",
        marginRight: 10,
        marginBottom: 10,
    },
    comentarWidth: {
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            width: "100%"
        }
    },
    nextButton: {
        width: "100%",
        lineHeight: "16px",
        [theme.breakpoints.down("sm")]: {
            width: "100%"
        },
    },
    selectedPet: {
        boxShadow: "0px 0px 10px 3px #273878",
        borderRadius: 10,
    },
    dayAvatar: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        fontSize: "10px",
        fontWeight: 700,
        marginRight: 18
    },
    availabilityText: {
        fontSize: "18px",
        textTransform: "uppercase",
        letterSpacing: "0.37px"
    },
    dataContainer: {
        rowGap: 20,
        padding: "10px 0",
        marginTop: "20px",
    },
    dataWrapper: {
        rowGap: 35,
    },
}));

interface AppointmentSummaryProps {
    bookAgain?: boolean
}

const AppointmentSummary: React.FC<AppointmentSummaryProps> = ({bookAgain}) => {
    const classes = useStyle();
    const [selectedPet, setSelectedPet] = useState<any>();
    const [selectedVet, setSelectedVet] = useState<any | undefined>();
    const [selectedServ, setSelectedServ] = useState<undefined | string>();
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const partnerId = useSelector((state: RootState ) => state?.branding.partnerId);
    const isGiftReceived = useSelector((state: RootState) => state?.scheduleAppointment.isGiftReceived);
    const [price, setPrice] = useState<undefined | string>();
    const [additionalInfo, setAdditionalInfo] = useState<string>(partnerId === 13 ? "This is a pre-wellness telehealth appointment to help prepare you for your pet's in-person clinic visit at East Atlanta Veterinary Clinic. This telehealth appointment will cover:\n" +
        "\n" +
        "•          Cost of care and your pet: breed specific considerations and importance of financial preparedness.\n" +
        "•          Preventive care considerations at different life stages: Establishing baseline bloodwork & the importance of protecting against regional parasites and preventable diseases.\n" +
        "\n" +
        "The duration of this appointment is 20 minutes and may cover some topics in more detail than others." : "");
    const {enqueueSnackbar} = useSnackbar();
    let history = useHistory();
    let isMobile = useMediaQuery("(min-width:960px)");
    let alignResonsive: GridItemsAlignment = isMobile ? "flex-start" : "center";
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const location = useSelector((state: RootState) => state?.common.location);
    const [referralCodeAvailable, setReferralCodeAvailable] = useState(false);
    const creditsAvailable = useSelector((state: RootState) => state?.credits.creditsAmount);
    const schedulingReducer = useSelector((state: RootState) => state?.scheduleAppointment);
    const [petName, setPetName] = useState("");
    const [hasSubscription, setHasSubscription] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [schedulingDays, setSchedulingDays] = useState([]);
    const [pickedTime, setPickedTime] = useState(null);
    const [bundleCount, setBundleCount] = useState(null);
    const [creditsInfo, setCreditsInfo] = useState([]);
    const timeZone = moment.tz.guess();
    const bundleType = schedulingReducer?.serviceType.includes("ADVICE") ? "ADVICE" : "DEFAULT";
    const isAdvice = bundleType === "ADVICE";
    const formattedPickedTimeSlot=[`${schedulingReducer.pickedTimeSlot}[${moment.tz.guess()}]`];

    const iOS = () => {
        return [
            "iPhone Simulator",
            "iPod Simulator",
            "iPhone",
            "iPod"
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document) || (navigator.userAgent.includes("Android") && "ontouchend" in document);
    };

    useEffect(() => {
        if (schedulingReducer.serviceType && !schedulingReducer.price) {
            dispatch(setSchedulePrice(getGuestBookingPrice(schedulingReducer.serviceType)));
        }
    }, [schedulingReducer.serviceType, schedulingReducer.price, dispatch]);

    useEffect(() => {
        api_getCreditRequestsCountByType(bundleType)
            .then((count) => {
                setBundleCount(count);
            });
        api_getCreditPrices(location, [bundleType])
            .then((prices) => setCreditsInfo(prices));
    }, []);

    useEffect(() => {
        if (schedulingReducer.serviceType === "RX_VIDEO") {
            dispatch(updatePromotionCode(""));
        }
    }, [schedulingReducer.serviceType, dispatch]);

    useEffect(() => {
        (async () => {
            if (user.role === "VET") {
                history.push("/");
            }
            if (user.userId) {
                const userEntity = await dispatch(getUserByID(user.userId));
                if (Object.prototype.hasOwnProperty.call(userEntity, "referralCodeRequest")) {
                    if (userEntity.referralCodeRequest.referralCodeRequestStatus !== "APPLIED" && moment(userEntity.referralCodeRequest.expiredAt) > moment()) {
                        setReferralCodeAvailable(true);
                    }
                }
                if (userEntity.ownerSubscriptionPlans?.length > 0) {
                    setHasSubscription(true);
                }
                const resAnimal = await API.getAnimalById(schedulingReducer.selectedPetId);
                setSelectedPet(resAnimal);
                setPetName(resAnimal.name || "");
                setSelectedVet(schedulingReducer.vetProfile);
                setSelectedServ(setType(schedulingReducer.serviceType));
                const resolvedPrice = schedulingReducer.price || getGuestBookingPrice(schedulingReducer.serviceType);
                setPrice(`$${resolvedPrice}`);
            } else {
                document.location.reload();
            }
        })();
    }, []);

    const handleClick = async () => {
        const link = appointmentsAdvice.includes(schedulingReducer.serviceType) ? "/disclaimer" : "/consent";
        let isAvailableToMoveForward = true;
        if (!additionalInfo || additionalInfo.trim() === "") {
            enqueueSnackbar("Please provide a reason for the appointment. The more details, the better!", {variant: "error"});
            isAvailableToMoveForward = false;
        }
        if (isAvailableToMoveForward) {
            dispatch(updateAdditionalInfo(additionalInfo));
            const clickUser = await API.getUserById(user.userId);
            // eslint-disable-next-line no-prototype-builtins
            if (clickUser.hasOwnProperty("partnerEntity")) {
                const associatedPartner = await API.getPartnerById(clickUser.partnerEntity.id);
                // if (!associatedPartner.subscription) {
                //     dispatch(postAppointmentRequest({
                //         vetUserId: schedulingReducer.vetId,
                //         animalId: schedulingReducer.selectedPetId,
                //         description: schedulingReducer.additionalInfo.trim(),
                //         chatId: schedulingReducer.selectedPetId,
                //         timesRequested: formattedPickedTimeSlot,
                //         appointmentType: schedulingReducer.serviceType,
                //     }))
                //         .then(async (res) => {
                //             if (schedulingReducer.pdf !== "") {
                //                 let imgData = schedulingReducer.pdf;
                //                 const pdf = new jsPDF();
                //                 pdf.addImage(imgData, "jpeg", 40 , iOS() ? 10 : 5, (iOS()) ? 30 : 130, 287, "consentForm", "NONE", 0);
                //                 // pdf.save("download.pdf");
                //                 const pdfParams = {
                //                     appointmentId: res.appointmentId,
                //                     clientId: user.userId,
                //                     imageUrl: "",
                //                     created: moment.utc().format(),
                //                     vetId: schedulingReducer.vetId
                //                 };
                //                 const firstStep = await API.addConsentForm(pdfParams).then(res => res.json());
                //                 const url = await API.getConsentURLs(firstStep.id);
                //                 const sendImage = await API.uploadConsentForm(url.uploadUrl, new Blob([pdf.output("blob")], {type: "application/pdf"}));
                //             }
                //             history.push({
                //                 pathname: "/appointmentConfirmation",
                //                 state: {
                //                     appointmentId: res.appointmentId,
                //                     type: res.appointmentType,
                //                 }
                //             });
                //         });
                // } else {
                    if (isGiftReceived) {
                        history.push("/gift");
                    } else history.push(link);
            } else {
                if (isGiftReceived) {
                    history.push("/gift");
                } else history.push(link);
            }
        }
    };

    const getVetsForDate = async () => {
        const day = new Date();
        try {
            const date = moment(day).tz(timeZone, true);
            const pet = await API.getAnimalById(schedulingReducer.selectedPetId);
            const petType = pet.type === "Other" ? pet.breed : pet.type;
            let specialtyForPet = "";
            let filteredType = specialities.filter(speciality => speciality.value === petType);
            let param = {
                type: "VET",
                specialties: filteredType.length > 0 ? [filteredType[0].value] : [specialtyForPet],
                desiredApptType: schedulingReducer.serviceType,
                clientTimeZone: timeZone,
                rangeBegins: date.format("YYYY-MM-DD"),
                rangeEnds: date.add(30, "days").format("YYYY-MM-DD"),
            };
            if (schedulingReducer.reasonType === "PRESCRIPTION") {
                Object.assign(param, {
                    states: [schedulingReducer.state],
                    prescriptionDesire: true
                });
            }
            const profiles = await API.getProfiles(param);
            const vetSchedulingDays = profiles.find(({id}) => id === schedulingReducer.vetProfile.id)?.schedulingDays;

            if (vetSchedulingDays && vetSchedulingDays.length) {
                setSchedulingDays(vetSchedulingDays);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        getVetsForDate();
    }, []);

    const handlePaymentWithCredits = () => {
        dispatch(updatePaymentMethod("WITH_CREDITS"));
        handleClick();
    };

    const handlePaymentWithReferralCode = () => {
        dispatch(updatePaymentMethod("WITH_REFERRAL_CODE"));
        handleClick();
    };

    const handlePaymentWithoutCredits = () => {
        dispatch(updatePaymentMethod("WITHOUT_CREDITS"));
        handleClick();
    };

    const handlePaymentWithBundlePurchase = () => {
        dispatch(updatePaymentMethod("PURCHASE_BUNDLE"));
        const option = isAdvice ? "FOUR_ADVICE_CREDITS" : "FOUR_CREDITS";
        const purchaseInfo = {
            clientUserId: user.userId,
            creditPrice: option,
            paymentRequest: {
                amount: `USD ${creditsInfo.find(({creditType}) => creditType === option)?.price.split(" ")[1]}`,
                type: "square",
            }
        };
        dispatch(createCredit(purchaseInfo));
        handleClick();
    };

    const handleNavBack = () => {
        history.push("/schedule");
    };

    const handleSubmitBookAgain = async () => {
        await dispatch(updatePickedTimeSlot([pickedTime]));
        if (referralCodeAvailable) {
            handlePaymentWithReferralCode();
        } else if (bundleCount) {
            handlePaymentWithCredits();
        } else {
            handlePaymentWithoutCredits();
        }
    };
    const Summary = <Grid container spacing={1} className={classes.wrapper} justify="flex-start"
        alignItems={alignResonsive}>
        <Grid container alignItems={alignResonsive} justify="flex-start">
            <Typography variant="h2" style={{wordBreak: "break-word"}}>
                Appointment Notes for {petName}
            </Typography>
        </Grid>
        {
            (!bookAgain || !!schedulingDays.length)
            &&
            <Grid container className={classes.rowContainer} alignItems={alignResonsive} justify="flex-start">
                <Typography variant="h3" align="center">
                    {moment(schedulingReducer.pickedTimeSlot[0]).format("dddd")}, {moment(schedulingReducer.pickedTimeSlot[0]).format("LL")} at {moment(schedulingReducer.pickedTimeSlot[0]).format("LT")}
                </Typography>
            </Grid>
        }
        <Grid container className={classes.doctorContainer} alignItems="flex-start">
            {
                selectedVet
                && (
                    <>
                        <Grid item key={selectedVet.id}>
                            <Box>
                                <Avatar variant="square" className={classes.avatar}>
                                    {
                                        {
                                            "vet": <Image alt="vet image" src={selectedVet.image} errorIcon={<DocSVG/>}
                                                imageStyle={{objectFit: "cover"}}
                                                style={{width: "100%"}}/>,
                                            "VET": <Image alt="vet image" src={selectedVet.image} errorIcon={<DocSVG/>}
                                                imageStyle={{objectFit: "cover"}}
                                                style={{width: "100%"}}/>,
                                            [selectedVet.type !== "vet" && selectedVet.type !== "Vet" && selectedVet.type]:
                                                <Box display="flex" justifyContent="center" alignItems="center"
                                                    width="100px" height="100px">
                                                    {selectedVet.image &&
                                                    <Image alt="vet image" imageStyle={{objectFit: "cover"}}
                                                        src={selectedVet.image} errorIcon={<DocSVG/>}
                                                        style={{width: "100%"}}/>}
                                                </Box>
                                        }[selectedVet.type]
                                    }
                                </Avatar>
                            </Box>
                        </Grid>
                        <Grid>
                            <Typography variant="h4" align="left">
                                Dr. {selectedVet.firstName} {selectedVet.lastName}
                            </Typography>
                            <Box className={classes.doctorDescription}>
                                <Typography variant="h4" align="left">
                                    Service
                                </Typography>
                                {!hasSubscription ?
                                    partnerId === 13 ?
                                        <Typography color="textSecondary" variant="subtitle1" align="left">
                                        Video - complimentary appointment ($35 value)
                                        </Typography>
                                        :
                                        <Typography color="textSecondary" variant="subtitle1" align="left">
                                            {selectedServ} - $75 for appointment
                                        </Typography>
                                    :
                                    <Typography color="textSecondary" variant="subtitle1" align="left">
                                        {selectedServ} - {schedulingReducer.reasonType !== "PRESCRIPTION" ? "appointment" : `$75 for appointment`}
                                    </Typography>
                                }
                            </Box>
                        </Grid>
                    </>
                )
            }
        </Grid>
        {bookAgain &&
        <Grid container direction="column" className={classes.dataContainer}>
            {schedulingDays.length ?
                <AppointmentTime
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    schedulingDays={schedulingDays}
                    pickedTimeSlot={pickedTime}
                    setPickedTimeSlot={setPickedTime}
                />
                :
                <Typography variant="h4">
                    No available workdays found.
                </Typography>}
        </Grid>
        }
        <Grid container alignItems={alignResonsive} justify="flex-start" className={classes.rowContainer}>
            <Typography variant="h4" align="center">
                Reason for Appointment
            </Typography>
        </Grid>
        <Grid container alignItems={alignResonsive} justify="flex-start" className={classes.rowContainer}>
            <TextField
                id="outlined-multiline-static"
                className={classes.comentarWidth}
                multiline
                rows={8}
                variant="outlined"
                required
                disabled={partnerId === 13}
                value={additionalInfo}
                placeholder={"Please provide your doctor as much detail as you can so that they are best \n" +
                "prepared to discuss what is important to you!"}
                onChange={((e) => {
                    setAdditionalInfo(e.target.value);
                })}
            />
        </Grid>
        <Grid container alignItems={alignResonsive} justify="flex-start" className={classes.rowContainer}>
            <Typography variant="h4" align="center">
                Upload photos (optional)
            </Typography>
        </Grid>
        <Grid container alignItems="flex-start" justify="flex-start" className={classes.rowContainer}>
            <Box className={classes.dropZone}>
                <DropZone onLoad={(val) => {
                    dispatch(uploadPhotos(val, 0));
                    // scheduleAppointmentHelper.setUploadPhotos(val, 0);
                }} deletePhoto={() => dispatch(cleanUpPhoto(0))} photo={schedulingReducer.uploadPhotos[0]} sizeLimit={false}/>
                <DropZone onLoad={(val) => {
                    dispatch(uploadPhotos(val, 1));
                    // scheduleAppointmentHelper.setUploadPhotos(val, 1);
                }} photo={schedulingReducer.uploadPhotos[1]} deletePhoto={() => dispatch(cleanUpPhoto(1))} sizeLimit={false}/>
                <DropZone onLoad={(val) => {
                    dispatch(uploadPhotos(val, 2));
                    // scheduleAppointmentHelper.setUploadPhotos(val, 2);
                }} photo={schedulingReducer.uploadPhotos[2]} deletePhoto={() => dispatch(cleanUpPhoto(2))} sizeLimit={false}/>
            </Box>
        </Grid>
        <Grid container alignItems={alignResonsive} justify="flex-start" className={classes.rowContainer}>
            <Typography variant="h4" align="center">
                Upload video (optional)
            </Typography>
        </Grid>
        <Grid container alignItems="flex-start" justify="flex-start" className={classes.rowContainer}>
            <Box className={classes.dropZone}>
                <DropZone type="video" onLoad={(val) => {
                    dispatch(uploadVideo(val));
                }} photo={schedulingReducer.uploadVideo} deletePhoto={() => dispatch(cleanUpVideo())}/>
            </Box>
        </Grid>
        {/* {!isWhiteLabel && !hasSubscription &&
        <Grid container alignItems={alignResonsive} justify="flex-start" className={classes.rowContainer}>
            <Typography variant="h4" align="center">
                <span style={{color: colorSecondary}}>{bundleCount} </span>
                Available Appointments
            </Typography>
        </Grid>
        } */}
        {bookAgain ?
            <Grid container direction="column" className={classes.dataContainer}>
                <Grid item>
                    <Button
                        type="button"
                        color="secondary"
                        variant="contained"
                        onClick={handleSubmitBookAgain}
                        disabled={schedulingDays.length ? false : true}
                        fullWidth
                    >
                        Save and Next
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="button"
                        variant="contained"
                        onClick={handleNavBack}
                        fullWidth
                    >
                        Back
                    </Button>
                </Grid>
            </Grid>
            :
            (bundleCount && !isWhiteLabel && !hasSubscription) ?
                <>
                    <Grid alignItems={alignResonsive} justify="flex-start" container className={classes.rowContainer}>
                        <Button type="button" color="secondary" variant="contained" onClick={handlePaymentWithCredits}
                            className={classes.nextButton}>Pay Using Discounted Bundle Appointment</Button>
                    </Grid>
                    <Grid alignItems={alignResonsive} justify="flex-start" container className={classes.rowContainer}
                        style={{marginTop: 10}}>
                        <Button type="button" variant="contained" onClick={handlePaymentWithoutCredits}
                            className={classes.nextButton}>Pay
                            for Single Appointment - {price}</Button>
                    </Grid>
                </>
                :
                (referralCodeAvailable && !isWhiteLabel && !hasSubscription) ?
                    <Grid alignItems={alignResonsive} justify="flex-start" container className={classes.rowContainer}
                        style={{marginTop: 10}}>
                        <Button type="button" color="secondary" variant="contained" onClick={handlePaymentWithReferralCode}
                            className={classes.nextButton}>Pay for appointment</Button>
                    </Grid>
                    :
                    ((schedulingReducer.serviceType === "RX_VIDEO" || schedulingReducer.serviceType.includes("ADVICE")) && (!isWhiteLabel || partnerId === 50)) ?
                        <>
                            {!hasSubscription &&
                            <>
                                {/* {partnerId !== 50 && <Grid alignItems={alignResonsive} justify="flex-start" container
                                    className={classes.rowContainer}>
                                    <Button type="button" color="secondary" variant="contained"
                                        onClick={handlePaymentWithBundlePurchase}
                                        className={classes.nextButton}>Purchase 4 Credit Bundle and Save
                                        {isAdvice ? " 21" : " 18"}%</Button>
                                </Grid>
                                } */}
                                <Grid alignItems={alignResonsive} justify="flex-start" container
                                    className={classes.rowContainer} style={{marginTop: 10}}>
                                    <Button type="button" variant="contained" onClick={handlePaymentWithoutCredits}
                                        className={classes.nextButton}>Next</Button>
                                </Grid>
                            </>
                            }
                            {hasSubscription &&
                            <Grid alignItems={alignResonsive} justify="flex-start" container
                                className={classes.rowContainer} style={{marginTop: 10}}>
                                <Button type="button" variant="contained" onClick={handlePaymentWithoutCredits}
                                    className={classes.nextButton}>Request Appointment</Button>
                            </Grid>
                            }
                        </>
                        : (hasSubscription || partnerId === 13) ? (
                            (schedulingReducer.serviceType !== "RX_VIDEO") ?
                                <Grid alignItems={alignResonsive} justify="flex-start" container
                                    className={classes.rowContainer}>
                                    <Button type="button" color="secondary" variant="contained" onClick={handlePaymentWithCredits}
                                        className={classes.nextButton}>Request Appointment</Button>
                                </Grid>
                                :
                                <Grid alignItems={alignResonsive} justify="flex-start" container
                                    className={classes.rowContainer}>
                                    <Button type="button" color="secondary" variant="contained" onClick={handlePaymentWithCredits}
                                        className={classes.nextButton}>Pay Using Discounted Bundle Appointment</Button>
                                </Grid>
                        ) :
                            (
                                <Grid alignItems={alignResonsive} justify="flex-start" container
                                    className={classes.rowContainer}>
                                    <Button type="button" color="secondary" variant="contained" onClick={handlePaymentWithoutCredits}
                                        className={classes.nextButton}>Pay for appointment</Button>
                                </Grid>
                            )
        }
    </Grid>;

    return (
        bookAgain ?
            Summary
            :
            <Container maxWidth="md" className={classes.cardWrapper}>
                <Card variant="outlined" style={{padding: 20}}>
                    {Summary}
                </Card>
            </Container>

    );
};

export default AppointmentSummary;
